import { UnwrapRef, reactive, watch } from '@vue/composition-api';
import _ from 'lodash';
import i18n, { i18n_t } from '@/locales/i18n';
import { IpcEvents } from '@/ipc-events';
import storage from '@/renderer/scripts/utils/storage';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import ipc from '@/renderer/scripts/utils/ipc';
import tips from '@/renderer/scripts/utils/tips';
export type SecuritySetting = {
  isbaitOpen: boolean;
  isAdmin: boolean;
};
type Handler = {
  securitySetting: UnwrapRef<SecuritySetting>;
  methods: {
    initSecuritySetting: () => void;
    reportInfo: (msgName: string, state: boolean) => void;
  };
};
export default function handler(): Handler {
  const securitySetting = reactive({
    isbaitOpen: false,
    isAdmin: false,
  });
  const methods = {
    reportInfo(msgName: string, state: boolean) {
      reporter.report('anti_ransomware', {
        ransomware_type: msgName,
        ransomware_state: state,
      });
    },
    initSecuritySetting() {
      const storageSecuritySetting = storage.get(storage.StoreKey.SECURITY_SETTING) as SecuritySetting;
      securitySetting.isbaitOpen = storageSecuritySetting.isbaitOpen;
      securitySetting.isAdmin = isAdminOrSuperAdmin.value;
    },
    async saveSecuritySetting() {
      const storageSecuritySetting = storage.get(storage.StoreKey.SECURITY_SETTING) as SecuritySetting;
      if (storageSecuritySetting.isbaitOpen === securitySetting.isbaitOpen) {
        logger.ui.info('saveSecuritySetting same config');
        return;
      }
      if (securitySetting.isbaitOpen) {
        methods.reportInfo('risk_sniffing', true);
        const ret = await ipc.invoke(IpcEvents.VIRUS_CHECK, {
          startCheck: true,
          init: true,
        });
        if (ret) {
          storage.set(storage.StoreKey.SECURITY_SETTING, securitySetting);
        } else {
          securitySetting.isbaitOpen = false;
          tips.error(i18n_t('风险嗅探开启失败'));
        }
      } else {
        storage.set(storage.StoreKey.SECURITY_SETTING, securitySetting);
        methods.reportInfo('risk_sniffing', false);
        ipc.invoke(IpcEvents.VIRUS_CHECK, {
          startCheck: false,
          deleteFile: true,
        });
      }
    },
  };
  const onSecuritySettingChange = _.debounce(
    () => {
      // 变更保存
      methods.saveSecuritySetting();
    },
    2000,
    {
      leading: true,
    },
  );
  watch(securitySetting, () => {
    onSecuritySettingChange();
  });
  return {
    methods,
    securitySetting,
  };
}
